import { render, staticRenderFns } from "./index.vue?vue&type=template&id=76c2503b&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c2503b')) {
      api.createRecord('76c2503b', component.options)
    } else {
      api.reload('76c2503b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=76c2503b&", function () {
      api.rerender('76c2503b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/sidebar/index.vue"
export default component.exports